import { css } from '@emotion/react/macro'
import { secondaryGrayColor, linkColor, linkHoverColor, primaryTextColor } from './colors'
import { oneDpShadowCss } from './shadows'

export const srOnlyCss = css`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
`

export const centerBlockCss = css`
  display: block;
  margin-left: auto;
  margin-right: auto;
`

export const pullRightCss = css`
  float: right;
`

export const linkCss = css`
  color: ${linkColor};
  font-weight: bold;

  &:focus,
  &:hover {
    color: ${linkHoverColor};
  }
`

export const dividerCss = css`
  border-bottom: 1px solid ${secondaryGrayColor};
`

export const dividerTopCss = css`
  border-top: 1px solid ${secondaryGrayColor};
`

export const cardCss = css`
  background-color: #ffffff;
  border-radius: 2px;
  margin-bottom: 40px;
  max-width: 550px;
  padding-bottom: 20px;
  ${oneDpShadowCss};
`

export const planCardCss = css`
  background: #ffffff;
  border-radius: 2px;
  min-height: 170px;
  line-height: 28px;
  text-align: left;
  padding-left: 17px;
  color: ${primaryTextColor};
  text-decoration: none;
`

export const fullPageCardCss = css`
  ${cardCss};
  max-width: unset;
  margin: 20px;
  padding: 30px 20px;
`

export const standardContainerCss = css`
  margin-bottom: 28px;
  padding: 10px 14px;
`

export const fieldsetCss = css`
  border: none;
  margin-inline-start: 0;
  margin-inline-end: 0;
  padding-block-start: 0;
  padding-inline-start: 0;
  padding-inline-end: 0;
  padding-block-end: 0;
`

export const rippleContainerCss = css`
  height: 48px;
  width: 48px;
  overflow: hidden;
  pointer-events: none;
  position: absolute;
  z-index: 0;
  margin-top: -12px;
  margin-left: -12px;
  border-radius: 50%;
`
